var next = __webpack_require__.x;
__webpack_require__.x = () => {
	__webpack_require__.e(0);
	__webpack_require__.e(1);
	return next();
};